export const APP_UPDATE_QUERY_PARAM = '_sorteia_build';

const BUILD_ID_PATTERN = /^[A-Za-z0-9_-]{1,80}$/;

export function readBuildId(payload: unknown): string | null {
  if (!payload || typeof payload !== 'object') return null;
  const value = (payload as { buildId?: unknown }).buildId;
  if (typeof value !== 'string' || !BUILD_ID_PATTERN.test(value)) return null;
  return value;
}

export function isNewBuild(currentBuild: string, candidateBuild: string | null): candidateBuild is string {
  if (!candidateBuild || !BUILD_ID_PATTERN.test(currentBuild)) return false;
  if (currentBuild === 'dev' || candidateBuild === 'dev') return false;
  return candidateBuild !== currentBuild;
}

/**
 * A unique main-document URL makes Chrome, an installed PWA and Android
 * WebView all perform a real navigation. The production shell is already
 * no-cache; the query value also prevents a stale intermediary from serving
 * the old index during the release window.
 */
export function reloadUrlForBuild(currentHref: string, nextBuild: string): string {
  const url = new URL(currentHref);
  url.searchParams.set(APP_UPDATE_QUERY_PARAM, nextBuild);
  return url.toString();
}

export function cleanReloadMarker(currentHref: string): string | null {
  const url = new URL(currentHref);
  if (!url.searchParams.has(APP_UPDATE_QUERY_PARAM)) return null;
  url.searchParams.delete(APP_UPDATE_QUERY_PARAM);
  return `${url.pathname}${url.search}${url.hash}`;
}
